import { pi, tau } from "../math.js";
export default {
  draw: function draw(context, size) {
    var r = Math.sqrt(size / pi);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau);
  }
};